import React from 'react';
import { Show, EditButton, TextField, NumberField, ReferenceManyField, Datagrid, DateField, ReferenceField, Pagination, translate } from 'react-admin';
import compose from 'recompose/compose';
import NoteField from '../stock_out_requests/NoteField';

const PercentageField = ({ record = {} }) => <span>{record.percentage * 100}%</span>;
PercentageField.defaultProps = {
    source: 'percentage',
    addLabel: true,
};

const PaymentIdField = ({ record }) => (
    <span><a href={`/#/payments/${record.id}`} style={{textDecoration: "none"}}>{record.purchaseId ? 'OR' + record.purchaseId.toString().padStart(5, '0') + 'P' + record.count : ''}</a></span>
);

const PaymentEmbedded = function({ permissions, ...props }) {
    
    return (
    /* Passing " " as title disables the custom title */
    <div>
        <h4 style={{fontWeight: 'normal'}}>{props.translate('resources.purchases.record.payment')}:</h4>
        <Show {...props}>
                <ReferenceManyField
                        reference="payments"
                        target="purchaseId"
                        pagination={<Pagination />}
                    >
                        <Datagrid>
                            <PaymentIdField label="resources.payments.fields.id" />
                            <DateField source="payment_date" options={{timeZone: "UTC"}}/>
                            <ReferenceField source="appUserId" reference="appusers" label="resources.payments.fields.user" >
                                <TextField source="username" />
                            </ReferenceField>
                            <TextField source="status" />
                            <NumberField source="amount" options={{ style: 'currency', currency: 'USD' }} />
                            <NumberField source="amount_cny" options={{ style: 'currency', currency: 'CNY' }} />
                            <PercentageField />
                            <TextField source="payment_type" />
                            <NoteField />
                            <EditButton />
                        </Datagrid>
                </ReferenceManyField>
        </Show>
    </div>
    );
}

PaymentEmbedded.propTypes = Show.propTypes;

const enhance = compose(
    translate
);

export default enhance(PaymentEmbedded);